<template>
    <div @keyup.enter="submitForm" v-if="fetched">
        <d-list-group flush>
            <d-list-group-item class="p-3">
                <d-form-row>
                    <d-col md="6" class="form-group">
                        <ss-input v-model="client.business_street" name="business_street" label="Ulica" placeholder="Ulica"></ss-input>
                    </d-col>
                    <d-col md="6">
                        <ss-input v-model="client.business_house_number" name="business_house_number" label="Nr budynku" placeholder="Nr budynku"></ss-input>
                    </d-col>
                </d-form-row>
                <d-form-row>
                    <d-col md="6" class="form-group">
                        <ss-input v-model="client.business_flat_number" name="business_flat_number" label="Nr lokalu" placeholder="Nr lokalu"></ss-input>
                    </d-col>
                </d-form-row>

                <d-form-row>
                    <d-col md="6" class="form-group">
                        <ss-input v-model="client.business_postcode" name="business_postcode" label="Kod pocztowy" placeholder="Kod pocztowy"></ss-input>
                    </d-col>
                    <d-col md="6">
                        <ss-input v-model="client.business_city" name="business_city" label="Miasto" placeholder="Miasto"></ss-input>
                    </d-col>
                </d-form-row>
            </d-list-group-item>
        </d-list-group>
    </div>
</template>

<script>
    import LarErrors from '../../helpers/Errors';

    export default {
        name: "AddressBusiness",
        components: {
            LarErrors
        },
        props: {
            props: {
                type: Object,
                default: {}
            }
        },
        data(){
            return{
                lar_errors: LarErrors,
                fetched:    false,
                client: {
                    business_street:          '',
                    business_house_number:    '',
                    business_postcode:        '',
                    business_city:            '',
                    business_flat_number:     ''
                }
            }
        },
        mounted(){
            this.client = this.props ? this.props : this.client;
            this.fetched = true;
        },
        watch: {
            props: {
                handler: function(to) {
                    this.client = to;
                    this.$forceUpdate();
                },
                deep: true
            }
        }
    }
</script>
